import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { POLL_UNREAD_COUNTS } from "@/lib/polling";

/**
 * Numero di messaggi non letti dell'utente corrente.
 *
 * Unico punto che interroga `/api/messages/unread`. Prima la query key era
 * condivisa da cinque componenti con queryFn diverse: alcune salvavano in cache
 * il numero, altre l'oggetto `{ count }` dell'endpoint. Vinceva l'ultimo fetch,
 * e chi si aspettava l'altra forma leggeva 0 (badge sparito nel menu mobile).
 * Qui la cache contiene sempre un numero.
 */
export function useUnreadCount(): number {
  const { user } = useAuth();
  const { data = 0 } = useQuery({
    queryKey: ["/api/messages/unread"],
    queryFn: async () => {
      const token = localStorage.getItem("auth_token");
      const headers: HeadersInit = token ? { Authorization: `Bearer ${token}` } : {};
      const response = await fetch("/api/messages/unread", {
        credentials: "include",
        headers,
      });
      if (!response.ok) return 0;
      const data = await response.json();
      return (data?.count ?? 0) as number;
    },
    refetchInterval: user ? POLL_UNREAD_COUNTS : false,
    enabled: !!user,
  });
  return data;
}
